var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{class:['date-input', { error: _vm.dateError }],attrs:{"disabled":_vm.disabled,"type":"text","placeholder":"mm / dd / yyyy"},domProps:{"value":_vm.displayValue},on:{"keyup":_vm.handleInput,"blur":_vm.handleBlur}})])}
var staticRenderFns = []

export { render, staticRenderFns }